import { Bar, mixins } from "vue-chartjs";
import "chartjs-plugin-annotation";
const { reactiveProp } = mixins;

export default {
  extends: Bar,

  mixins: [reactiveProp],

  props: {
    goalLine: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: false
    },

    legendPosition: {
      type: String,
      default: "top",
      validator: function(value) {
        // The value must match one of these strings
        return ["bottom", "top", "left", "right"].includes(value);
      }
    }
  },

  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
          labels: {
            fontFamily: "Manrope, Lato, sans-serif",
            fontSize: 24,
            usePointStyle: true,
            boxWidth: 14
          }
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                fontFamily: "Manrope, Lato, sans-serif",
                fontSize: 16,
                beginAtZero: true,
                callback: function(value) {
                  return Math.abs(value) > 999
                    ? Math.sign(value) * (Math.abs(value) / 1000).toFixed(1) +
                        "k"
                    : Math.sign(value) * Math.abs(value);
                }
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                fontFamily: "Manrope, Lato, sans-serif",
                fontSize: 16
              }
            }
          ]
        },
        tooltips: {
          mode: "index",
          titleFontFamily: "Manrope, Lato, sans-serif",
          titleFontSize: 24,
          bodyFontFamily: "Manrope, Lato, sans-serif",
          bodyFontSize: 18,
          footerFontFamily: "Manrope, Lato, sans-serif",
          footerFontSize: 18,
          callbacks: {
            label: function(tooltipItem, data) {
              //  round and add thousandths separator to number
              let label = data.datasets[tooltipItem.datasetIndex].label || "";
              if (label) {
                label += ": ";
              }
              label += Math.round(tooltipItem.yLabel)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              return label;
            },
            footer: tooltipItems => {
              if (tooltipItems.length > 1) {
                let total = tooltipItems.reduce(
                  (acc, curr) => acc + parseInt(curr.yLabel),
                  0
                );
                return "Total: " + total.toLocaleString();
              }
            }
          }
        }
      }
    };
  },

  mounted() {
    if (this.goalLine) {
      this.options.annotation = {
        events: ["mouseenter"],
        annotations: [
          {
            type: "line",
            mode: "horizontal",
            scaleID: "y-axis-0",
            value: this.goalLine,
            borderColor: this._app_chart_colors_multiple.navy,
            borderWidth: 4,
            label: {
              backgroundColor: this._app_chart_colors_multiple.teal,
              // Whether the label is enabled and should be displayed
              enabled: false,
              // Text to display in label - default is null. Provide an array to display values on a new line
              content: "Goal"
            },
            onMouseenter: function() {
              let element = this;
              element.chartInstance.options.annotation.annotations[0].label.enabled = true;
              element.chartInstance.chart.update();
              setTimeout(() => {
                element.chartInstance.options.annotation.annotations[0].label.enabled = false;
                element.chartInstance.chart.update();
              }, 900);
            }
          }
        ],
        drawTime: "afterDatasetsDraw"
      };
    }
    this.$emit("add-background-color", this.addBackgroundColor());
    this.renderChart(this.chartData, this.options);
  },

  methods: {
    addBackgroundColor() {
      let canvas = this.$refs.canvas.getContext("2d");
      const { steps, activities } = this._app_chart_two_color;
      const colors = [steps, activities];

      return context => {
        const colorKeys = Object.keys(colors);
        let colorKey = colorKeys[context.datasetIndex % colorKeys.length];
        let color = colors[colorKey];
        let gradientFill = canvas.createLinearGradient(
          0,
          context.chart.height,
          0,
          0
        );
        gradientFill.addColorStop(0, "white");
        gradientFill.addColorStop(0.3, color);
        return gradientFill;
      };
    }
  }
};
